<template>
  <v-overlay :value="appLoading" color="white">
    <v-progress-circular color="primary" indeterminate size="80" />
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LLoading',
  computed: {
    ...mapState('common', ['appLoading']),
  },
};
</script>
